import React from 'react';
import { FormControl, Select, MenuItem, InputLabel, FormHelperText } from '@mui/material';
import useSetupConfig from '../../hooks/useSetupConfig';

const fontBase = { fontFamily: 'Roboto, Arial, sans-serif' };

/**
 * The department dropdown, used wherever a department is chosen.
 *
 * Options come from the departments SetupConfig category — the same list the
 * server validates against — so the two cannot drift. useSetupConfig caches at
 * module level, so rendering several of these costs one request.
 */
const DepartmentSelect = ({
  value,
  onChange,
  label = 'Department',
  required = false,
  disabled = false,
  error = false,
  helperText = '',
  size = 'small',
  sx = {},
  includeAll = false,
  allLabel = 'All departments',
}) => {
  const { names, loading } = useSetupConfig('departments');

  return (
    <FormControl size={size} fullWidth error={error} disabled={disabled || loading} sx={sx}>
      <InputLabel sx={{ ...fontBase, fontSize: '14px' }}>
        {label}{required ? ' *' : ''}
      </InputLabel>
      <Select
        value={value || ''}
        label={`${label}${required ? ' *' : ''}`}
        onChange={(e) => onChange(e.target.value)}
        sx={{ ...fontBase, fontSize: '14px', backgroundColor: '#fff', borderRadius: '8px' }}
      >
        {includeAll && (
          <MenuItem value="" sx={{ ...fontBase, fontSize: '14px' }}>
            {allLabel}
          </MenuItem>
        )}
        {includeAll && (
          <MenuItem value="__unassigned" sx={{ ...fontBase, fontSize: '14px' }}>
            Unassigned
          </MenuItem>
        )}
        {!includeAll && names.length === 0 && (
          <MenuItem value="" disabled sx={{ ...fontBase, fontSize: '14px' }}>
            {loading ? 'Loading…' : 'No departments configured — add them under Setups'}
          </MenuItem>
        )}
        {names.map((name) => (
          <MenuItem key={name} value={name} sx={{ ...fontBase, fontSize: '14px' }}>
            {name}
          </MenuItem>
        ))}
      </Select>
      {helperText ? (
        <FormHelperText sx={{ ...fontBase }}>{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default DepartmentSelect;
